// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"2a00b0af","498":"802fe54f","513":"17268256"}[chunkId] + ".chunk.js";
};